import { render, staticRenderFns } from "./incoming.vue?vue&type=template&id=172224a6&scoped=true&"
import script from "./incoming.vue?vue&type=script&lang=js&"
export * from "./incoming.vue?vue&type=script&lang=js&"
import style0 from "./incoming.vue?vue&type=style&index=0&id=172224a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172224a6",
  null
  
)

export default component.exports